import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomainDetailsComponent } from './domain-details.component';
import { DomainOverviewRisk } from './domain-overview-risk/domain-overview-risk';
import { DomainMoreDetails } from './domain-more-details/domain-more-details';
import { DomainTrafficQualityRisk } from './traffic-quality-risk/traffic-quality-risk';
import { DomainSiteRisk } from './site-risk/site-risk';
import { DomainSiteInformation } from './site-information/site-information';
import { DomainBrandSafetyRisk } from './brand-safety-risk/brand-safety-risk';
import { DomainSocialMedia } from './social-media/social-media';
import { DomainIvt } from './domain-ivt/domain-ivt';
import { DomainIvtOverview } from './domain-ivt-overview/domain-ivt-overview.component';
import { DomainInventory } from './domain-inventory/domain-inventory';
import { DomainSov } from './domain-sov/domain-sov';
import { DomainViewability } from './domain-viewability/domain-viewability';
import { DomainReferralTraffic } from './referral-traffic/referral-traffic';
import { DomainInfoComponent } from './domain-info/domain-info.component';
import { DirectivesModule } from '../../../../directives/directives.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { DataTableModule } from '../../../data-table/data-table.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { routing } from './domain-details.routing';
import { ReferralTrafficSection } from './referral-traffic/referral-traffic-section';
import { TopSubDomains } from './top-sub-domains/top-sub-domains';
import { DeviceDistribution } from './device-distribution/device-distribution';
import { DomainCtrComponent } from './domain-ctr/domain-ctr.component';
import { SharedModule } from '../../../shared/shared.module';
import { DetailsPageModule } from '../details-page/details-page.module';
import { AppDomainOverviewSectionComponent } from './sections/app-domain-overview-section/app-domain-overview-section.component';
import { AppDomainRiskOverviewSectionComponent } from './sections/app-domain-risk-overview-section/app-domain-risk-overview-section.component';
import { AppDomainDetailsSectionComponent } from './sections/app-domain-details-section/app-domain-details-section.component';
import { AppDomainIvtSectionComponent } from './sections/app-domain-ivt-section/app-domain-ivt-section.component';
import { AppDomainInventorySectionComponent } from './sections/app-domain-inventory-section/app-domain-inventory-section.component';
import { AppDomainSovSectionComponent } from './sections/app-domain-sov-section/app-domain-sov-section.component';
import { AppDomainViewabilitySectionComponent } from './sections/app-domain-viewability-section/app-domain-viewability-section.component';
import { AppDomainCtrSectionComponent } from './sections/app-domain-ctr-section/app-domain-ctr-section.component';
import { AppReferralTrafficSectionComponent } from './sections/app-referral-traffic-section/app-referral-traffic-section.component';
import { AppDomainSubdomainsSectionComponent } from './sections/app-domain-subdomains-section/app-domain-subdomains-section.component';
import { AppDomainDeviceDistributionSectionComponent } from './sections/app-domain-device-distribution-section/app-domain-device-distribution-section.component';
import { SwiperModule } from 'swiper/angular';
import { ChartsModule } from '../../charts/charts.module';
import { DomainFraudtypesComponent } from './domain-fraudtypes/domain-fraudtypes.component';
import { DomainFraudTrafficComponent } from './domain-fraud-traffic/domain-fraud-traffic.component';
import { InsightBadgesModule } from '../../../shared/insight-badges/insight-badges.module';
import { DomainMfa } from './domain-mfa/domain-mfa';
import { AppDomainCookieBannerSectionComponent } from './sections/app-domain-cookie-banner-section/app-domain-cookie-banner-section.component';
import { DomainCookieBanner } from './domain-cookie-banner/domain-cookie-banner';
import { AppDomainEngagementMetricsSectionComponent } from './sections/app-domain-engagement-metrics-section/app-domain-engagement-metrics-section.component';
import { DomainUserEngagement } from './domain-user-engagement/domain-user-engagement';
import { DomainAdPerformance } from './domain-ad-performance/domain-ad-performance';
import { DomainUserBehavior } from './domain-user-behavior/domain-user-behavior';
import { DomainContributionPlatform } from './domain-contribution-platform/domain-contribution-platform';

@NgModule({
  imports: [
    DetailsPageModule,
    DirectivesModule,
    TooltipModule,
    DataTableModule,
    PipesModule,
    CommonModule,
    routing,
    SharedModule,
    SwiperModule,
    ChartsModule,
    InsightBadgesModule
  ],
  exports: [DomainCtrComponent],
  declarations: [
    ReferralTrafficSection,
    TopSubDomains,
    DeviceDistribution,
    DomainInfoComponent,
    DomainDetailsComponent,
    DomainOverviewRisk,
    DomainMoreDetails,
    DomainCookieBanner,
    DomainTrafficQualityRisk,
    DomainSiteRisk,
    DomainSiteInformation,
    DomainBrandSafetyRisk,
    DomainSocialMedia,
    DomainIvt,
    DomainIvtOverview,
    DomainInventory,
    DomainSov,
    DomainViewability,
    DomainReferralTraffic,
    DomainCtrComponent,
    AppDomainOverviewSectionComponent,
    AppDomainRiskOverviewSectionComponent,
    AppDomainDetailsSectionComponent,
    AppDomainCookieBannerSectionComponent,
    AppDomainIvtSectionComponent,
    AppDomainInventorySectionComponent,
    AppDomainSovSectionComponent,
    AppDomainViewabilitySectionComponent,
    AppDomainCtrSectionComponent,
    AppReferralTrafficSectionComponent,
    AppDomainSubdomainsSectionComponent,
    AppDomainDeviceDistributionSectionComponent,
    AppDomainEngagementMetricsSectionComponent,
    DomainFraudtypesComponent,
    DomainFraudTrafficComponent,
    DomainMfa,
    DomainUserEngagement,
    DomainAdPerformance,
    DomainUserBehavior,
    DomainContributionPlatform
  ]
})
export class DomainDetailsModule {}
